const assetContext = require.context('../images', true, /\.(png|jpe?g|webp|gif|svg|mp4|webm)$/);

const resolveAsset = (relativePath) => {
  const normalized = relativePath.replace(/^\.?\//, '');
  try {
    return assetContext(`./${normalized}`);
  } catch (error) {
    console.warn(`[projects] Asset not found: ${relativePath}`);
    return '';
  }
};

export const projects = [
  {
    id: 1,
    year: "2025",
    date: "June 2025",
    readTime: "~8 min. read",
    title: "Intern onboarding website — Friends of Cartel thesis",
    shortTitle: "thesis-onboarding",
    imageAlt: "Friends of Cartel intern onboarding website UI — thesis web design by Sander Kuyken",
    description:
      "Interactive onboarding website for future interns at Friends of Cartel: Webflow prototypes, AI-assisted content and video modules in one guided journey from day one to first project.",
    teaser:
      "Graduaat thesis case — interactive intern onboarding site for Friends of Cartel, from UX and Webflow prototype to motion-led modules.",
    tag: "Design",
    // Darker blue so white card text meets WCAG contrast on Selected Works.
    color: "#1a4fbf",
    image: resolveAsset('thesis-onboarding/project-1-img-25.webp'),
    relatedLinks: {
      insightSlug: 'website-that-actually-converts',
      servicePath: '/services#web-design',
      label: 'Web / UX design',
    },
    hoverImage: resolveAsset('thesis-onboarding/project-1-img-13.webp'),
    sector: "Education",
    services: "Experience Design, Onboarding Strategy, Motion Design",
    technologies: "GSAP, Figma, Webflow, AI, After Effects, Premiere Pro, Blender, Photoshop, Illustrator",
    siteUrl: "https://ioxeds-exceptional-site.webflow.io/",
    caseStudy: {
      challenge:
        "New interns at Friends of Cartel were onboarded ad-hoc, with scattered docs and no shared starting point — slow to get productive and easy to overwhelm.",
      approach:
        "I designed a single, guided onboarding journey: Webflow prototypes, AI-assisted content and bite-sized video modules sequenced into one clear path from day one to first project.",
      result:
        "A cohesive onboarding experience that turns a messy first week into a confident, self-paced ramp — and a thesis case covering the full concept-to-presentation process.",
      role: "Concept, UX, motion & build",
      deliverables: ["UX flow", "Webflow prototype", "Video modules", "Onboarding content"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "Look at the website Urself",
        description: "https://ioxeds-exceptional-site.webflow.io/"
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/final-thesis-project",
        images: [
          { src: resolveAsset('thesis-onboarding/project-1-img-14.webp'), enabled: true },
          { src: resolveAsset('thesis-onboarding/project-1-img-15.webp'), enabled: true },
          { src: resolveAsset('thesis-onboarding/project-1-img-2.webp'), enabled: true },
          { src: resolveAsset('thesis-onboarding/project-1-img-21.webp'), enabled: true },
          { src: resolveAsset('thesis-onboarding/project-1-img-22.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/final-thesis-project",
        images: [
          resolveAsset('thesis-onboarding/project-1-img-10.webp'),
          resolveAsset('thesis-onboarding/project-1-img-13.webp'),
          resolveAsset('thesis-onboarding/project-1-img-11.webp'),
          resolveAsset('thesis-onboarding/project-1-img-6.webp'),
          resolveAsset('thesis-onboarding/project-1-img-7.webp'),
          resolveAsset('thesis-onboarding/project-1-img-20.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('thesis-onboarding/project-1-img-25.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 2,
    year: "2025",
    date: "April 2025",
    readTime: "~4 min. read",
    title: "Bilzen-Hoeselt social media motion graphics",
    shortTitle: "bilzen-hoeselt-motion",
    imageAlt: "Bilzen-Hoeselt branded social media motion graphics frame",
    description:
      "Branded social animation series for Bilzen-Hoeselt — local events turned into punchy motion clips with consistent colour, type and pacing for municipal feeds.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('bilzen-hoeselt-motion/project-2-img-1.webp'),
    relatedLinks: {
      insightSlug: 'what-motion-design-adds-to-a-brand',
      servicePath: '/services#motion-design',
      label: 'Motion design',
    },
    hoverImage: resolveAsset('bilzen-hoeselt-motion/project-2-vid-2.webm'),
    sector: "Municipality & Tourism",
    services: "Social Content, Animation Production",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Bilzen-Hoeselt needed short social motion that felt local and energetic without looking like generic template packs.",
      approach:
        "During my Friends of Cartel internship I built branded clips — testing colour, type accents and pacing so each event still felt part of one campaign system.",
      result:
        "A consistent motion language for municipal social content that stands out in feed and stays on-brand across events.",
      role: "Motion design",
      deliverables: ["Social animation series", "Branded motion system", "Typographic accents"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "",
        images: [],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO'S",
        videoSrc: resolveAsset('bilzen-hoeselt-motion/project-2-vid-1.webm'),
        videoThumbnail: resolveAsset('bilzen-hoeselt-motion/project-2-img-1.webp')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/bilzen-hoeselt-animations",
        images: [
          resolveAsset('bilzen-hoeselt-motion/project-2-vid-1.webm'),
          resolveAsset('bilzen-hoeselt-motion/project-2-vid-2.webm'),
          
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('bilzen-hoeselt-motion/project-2-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 3,
    year: "2025",
    date: "May 2025",
    readTime: "~4 min. read",
    title: "Multipharma pharmacy motion graphics",
    shortTitle: "multipharma-motion",
    imageAlt: "Multipharma pharmacy motion graphics animation still",
    description:
      "Motion graphics that make Multipharma pharmacy services clearer: icon animation, soft 3D accents and timed reveals for social and digital campaigns.",
    teaser:
      "Pharmacy services explained in motion — clear iconography and brand rhythm built for Multipharma social and web.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('multipharma-motion/project-3-img-2.webp'),
    relatedLinks: {
      insightSlug: 'what-motion-design-adds-to-a-brand',
      servicePath: '/services#motion-design',
      label: 'Motion design',
    },
    hoverImage: resolveAsset('multipharma-motion/project-3-vid-3.webm'),
    sector: "Healthcare",
    services: "Motion Design, Information Design",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Multipharma needed motion that makes pharmacy services clearer and more approachable without feeling clinical.",
      approach:
        "I translated complex information into clear animations with iconography, subtle 3D and soft transitions inside the Friends of Cartel team.",
      result:
        "A motion package that makes service stories easier to scan and more memorable across digital touchpoints.",
      role: "Motion graphics",
      deliverables: ["Motion sequences", "Icon animation", "Social-ready exports"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/multipharma-motion-graphics",
        images: [
          { src: resolveAsset('multipharma-motion/project-3-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('multipharma-motion/project-3-vid-1.webm'),
        videoThumbnail: resolveAsset('multipharma-motion/project-3-img-1.webp')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/multipharma-motion-graphics",
        images: [
          resolveAsset('multipharma-motion/project-3-vid-1.webm'),
          resolveAsset('multipharma-motion/project-3-vid-2.webm'),
          resolveAsset('multipharma-motion/project-3-vid-3.webm'),
          resolveAsset('multipharma-motion/project-3-vid-4.webm'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('multipharma-motion/project-3-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 4,
    year: "2025",
    date: "March 2025",
    readTime: "~3 min. read",
    title: "RCA Cafe networking event poster",
    shortTitle: "rca-cafe-poster",
    imageAlt: "RCA Cafe networking event poster design",
    description:
      "Print and digital poster for the RCA Cafe networking evening at Cartel Agency — hand-drawn accents and expressive typography for a playful event vibe.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('rca-cafe-poster/project-4-img-1.webp'),
    hoverImage: resolveAsset('rca-cafe-poster/project-4-img-2.webp'),
    sector: "Events & Culture",
    services: "Print Design, Campaign Collateral",
    technologies: "Illustrator, Photoshop, Procreate",
    siteUrl: "",
    caseStudy: {
      challenge:
        "RCA Cafe needed a poster for a Cartel Agency networking evening that felt playful and event-ready in print and digital.",
      approach:
        "I combined hand-drawn elements with expressive typography so the vibe reads instantly on a wall and on screen.",
      result:
        "Print and digital poster variants that stand out as campaign assets for the March 2025 evening.",
      role: "Poster design",
      deliverables: ["Print poster", "Digital variant", "Hand-drawn accents"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/rca-cafe-poster",
        images: [
          { src: resolveAsset('rca-cafe-poster/project-4-img-1.webp'), enabled: true },
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/rca-cafe-poster",
        images: [
          resolveAsset('rca-cafe-poster/project-4-img-1.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('rca-cafe-poster/project-4-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 5,
    year: "2025",
    date: "May 2025",
    readTime: "~3 min. read",
    title: "Becoland typography logo animation",
    shortTitle: "becoland-logo-motion",
    imageAlt: "Becoland typography logo animation still",
    description:
      "Typography-driven logo animation for Becoland with tested rhythm, glow and loop frames — ready for events and digital brand moments.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('becoland-logo-motion/project-5-img-1.webp'),
    relatedLinks: {
      insightSlug: 'branding-basics-for-small-businesses',
      servicePath: '/services#branding',
      label: 'Branding',
    },
    hoverImage: resolveAsset('becoland-logo-motion/project-5-vid-1.webm'),
    sector: "Food & Leisure",
    services: "Logo Animation, Brand Motion Toolkit",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Becoland needed a logo animation that feels alive online and at events without breaking Friends of Cartel guidelines.",
      approach:
        "I tested rhythm, glow and transition frames so the mark reads in short loops and longer brand moments.",
      result:
        "A typography-driven logo animation aligned with the May 2025 style guidelines.",
      role: "Logo animation",
      deliverables: ["Logo animation", "Loop variants", "Event-ready exports"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/becoland-logo-animation",
        images: [
          { src: resolveAsset('becoland-logo-motion/project-5-img-1.webp'), enabled: true },
          { src: resolveAsset('becoland-logo-motion/project-5-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('becoland-logo-motion/project-5-vid-1.webm'),
        videoThumbnail: resolveAsset('becoland-logo-motion/project-5-img-1.webp')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/becoland-logo-animation",
        images: [
          resolveAsset('becoland-logo-motion/project-5-vid-1.webm'),
          resolveAsset('becoland-logo-motion/project-5-vid-2.webm'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('becoland-logo-motion/project-5-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 6,
    year: "2025",
    date: "2025",
    readTime: "~3 min. read",
    title: "Palpatine VFX colour grading study",
    shortTitle: "palpatine-vfx",
    imageAlt: "Palpatine VFX colour grading and compositing study",
    description:
      "Cinematic VFX study bringing Emperor Palpatine to life through colour grading, rotoscoping and compositing energy effects.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('palpatine-vfx/project-6-img-1.webp'),
    hoverImage: resolveAsset('palpatine-vfx/project-6-vid-1.webm'),
    sector: "Entertainment",
    services: "Compositing, VFX Experimentation",
    technologies: "After Effects, Photoshop, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Bring Emperor Palpatine to life in a VFX study with believable grading, rotoscoping and compositing.",
      approach:
        "I experimented with colour, energy effects and plate integration until the silhouette and power read clearly.",
      result:
        "A VFX study that demonstrates grading, rotoscoping and compositing craft in one cinematic beat.",
      role: "VFX & compositing",
      deliverables: ["VFX shot", "Colour grade", "Compositing passes"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/palpatine-vfx-study",
        images: [
          { src: resolveAsset('palpatine-vfx/project-6-img-1.webp'), enabled: true },
          { src: resolveAsset('palpatine-vfx/project-6-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('palpatine-vfx/project-6-vid-1.webm'),
        videoThumbnail: resolveAsset('palpatine-vfx/project-6-img-1.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/palpatine-vfx-study",
        images: [
          resolveAsset('palpatine-vfx/project-6-vid-1.webm'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('palpatine-vfx/project-6-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 7,
    year: "2025",
    date: "2025",
    readTime: "~3 min. read",
    title: "Spider-Man VFX camera tracking experiment",
    shortTitle: "spiderman-vfx",
    imageAlt: "Spider-Man VFX camera tracking experiment still",
    description:
      "Short Spider-Man VFX experiment combining camera tracking, 3D web simulation and timed impacts in a cinematic loop.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('spiderman-vfx/project-7-img-1.webp'),
    hoverImage: resolveAsset('spiderman-vfx/project-7-vid-1.webm'),
    sector: "Entertainment",
    services: "Compositing, Motion Exploration",
    technologies: "After Effects, Blender, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Explore superhero VFX in a short Spider-Man piece without a full feature pipeline.",
      approach:
        "I combined camera tracking with 3D web simulation and timed impacts so the experiment still feels cinematic.",
      result:
        "A punchy personal VFX experiment showcasing tracking, simulation and energy.",
      role: "VFX experiment",
      deliverables: ["Tracked shot", "3D web sim", "Composited sequence"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/spider-man-vfx-experiment",
        images: [
          { src: resolveAsset('spiderman-vfx/project-7-img-1.webp'), enabled: true },
          { src: resolveAsset('spiderman-vfx/project-7-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('spiderman-vfx/project-7-vid-1.webm'),
        videoThumbnail: resolveAsset('spiderman-vfx/project-7-img-1.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('spiderman-vfx/project-7-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 8,
    year: "2025",
    date: "March 2025",
    readTime: "~4 min. read",
    title: "Handmade stop-motion short film",
    shortTitle: "stop-motion-film",
    imageAlt: "Handmade stop-motion short film frame",
    description:
      "Stop-motion film for a Motion Design course — frame-by-frame photography, tactile textures and lighting that carry the story.",
    tag: "Motion",
    color: "#fd521a",
    image: resolveAsset('stop-motion-film/project-8-img-1.webp'),
    hoverImage: resolveAsset('stop-motion-film/project-8-vid-1.webm'),
    sector: "Education",
    services: "Stop-Motion Production, Sound Design",
    technologies: "Dragonframe, Premiere Pro, Photoshop",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Produce a stop-motion film where tactile textures lead the story for a Motion Design course.",
      approach:
        "I photographed every frame, controlled lighting and paced physical motion so small movements still read as intentional.",
      result:
        "A handmade stop-motion piece that showcases patience, framing and material craft.",
      role: "Stop-motion & direction",
      deliverables: ["Stop-motion film", "Frame sequence", "Set lighting"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/stop-motion-film",
        images: [
          { src: resolveAsset('stop-motion-film/project-8-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('stop-motion-film/project-8-vid-1.webm'),
        videoThumbnail: resolveAsset('stop-motion-film/project-8-img-1.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('stop-motion-film/project-8-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 9,
    year: "2024",
    date: "2024",
    readTime: "~3 min. read",
    title: "Dreaming — Kanye West audiovisual edit",
    shortTitle: "dreaming-visual-edit",
    imageAlt: "Dreaming audiovisual music edit still — Kanye West track",
    description:
      "Audiovisual experiment set to Kanye West’s Dreaming — footage, glitch overlays and typography cut to the track’s emotional arc.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('dreaming-visual-edit/project-9-img-1.webp'),
    hoverImage: resolveAsset('dreaming-visual-edit/project-9-vid-1.webm'),
    sector: "Entertainment",
    services: "Video Editing, Visual Effects",
    technologies: "After Effects, Premiere Pro, Photoshop",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Build an audiovisual experiment to Kanye West’s Dreaming that feels intentional, not random flash cuts.",
      approach:
        "I blended footage, glitch-like overlays and typographic moments cut to the track’s emotional arc.",
      result:
        "A music-driven visual edit with clear pacing and a cohesive atmospheric attitude.",
      role: "Visual edit & direction",
      deliverables: ["Audiovisual edit", "Graphic overlays", "Colour look"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/dreaming-visual-edit",
        images: [
          { src: resolveAsset('dreaming-visual-edit/project-9-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('dreaming-visual-edit/project-9-vid-1.webm'),
        videoThumbnail: resolveAsset('dreaming-visual-edit/project-9-img-1.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: false,
        src: resolveAsset('dreaming-visual-edit/project-9-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 10,
    year: "2025",
    date: "2025",
    readTime: "~6 min. read",
    title: "Charged lifestyle brand identity & ads",
    shortTitle: "charged-branding",
    imageAlt: "Charged lifestyle brand identity logo and advertising layout",
    description:
      "Bold lifestyle branding for Charged: logo, modular ad layouts and social templates with high contrast so fourteen deliverables stay one system.",
    tag: "Branding",
    color: "#13006c",
    image: resolveAsset('charged-branding/project-10-img-2.webp'),
    relatedLinks: {
      insightSlug: 'branding-basics-for-small-businesses',
      servicePath: '/services#branding',
      label: 'Branding',
    },
    hoverImage: resolveAsset('charged-branding/project-10-img-2.webp'),
    sector: "Lifestyle & Retail",
    services: "Brand Identity, Creative Direction, Advertising Toolkit",
    technologies: "Illustrator, Photoshop, InDesign",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Charged needed a bold lifestyle identity that stays recognisable across logo, ads and social without drifting.",
      approach:
        "I built a modular visual system with strong contrast and repeatable layouts so fourteen deliverables still feel like one brand.",
      result:
        "A high-energy identity system that scales from logo to campaign ads while staying consistent.",
      role: "Branding & campaign design",
      deliverables: ["Logo", "Ad system", "Social templates", "Brand layouts"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/charged-logo-and-ads",
        images: [
          { src: resolveAsset('charged-branding/project-10-img-12.webp'), enabled: true },
          { src: resolveAsset('charged-branding/project-10-img-13.webp'), enabled: true },
          { src: resolveAsset('charged-branding/project-10-img-14.webp'), enabled: true },
          { src: resolveAsset('charged-branding/project-10-img-15.webp'), enabled: true },
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/charged-logo-and-ads",
        images: [
          resolveAsset('charged-branding/project-10-img-2.webp'),
          resolveAsset('charged-branding/project-10-img-3.webp'),
          resolveAsset('charged-branding/project-10-img-4.webp'),
          resolveAsset('charged-branding/project-10-img-5.webp'),
          resolveAsset('charged-branding/project-10-img-6.webp'),
          resolveAsset('charged-branding/project-10-img-7.webp'),
          resolveAsset('charged-branding/project-10-img-8.webp'),
          resolveAsset('charged-branding/project-10-img-9.webp'),
          resolveAsset('charged-branding/project-10-img-10.webp'),
          resolveAsset('charged-branding/project-10-img-11.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('charged-branding/project-10-img-2.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 11,
    year: "2025",
    date: "2025",
    readTime: "~5 min. read",
    title: "Hasselt Shopping Sundays city campaign",
    shortTitle: "hasselt-shopping-sundays",
    imageAlt: "Hasselt Shopping Sundays city campaign poster design",
    description:
      "Campaign identity for the City of Hasselt Shopping Sundays — posters, animations and social posts that position Hasselt as a vibrant monthly meeting place.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('hasselt-shopping-sundays/project-11-img-1.webp'),
    hoverImage: resolveAsset('hasselt-shopping-sundays/project-11-img-5.gif'),
    sector: "Government & Public Sector",
    services: "Campaign Identity, Motion Assets, Social Content",
    technologies: "Illustrator, After Effects, Photoshop",
    siteUrl: "",
    caseStudy: {
      challenge:
        "The City of Hasselt needed a campaign identity for monthly Shopping Sundays that feels civic, festive and clear in public space.",
      approach:
        "Starting from audience research I built a colourful visual language across posters, animations and social posts.",
      result:
        "A campaign system that positions Hasselt as a vibrant meeting place and communicates the event at a glance.",
      role: "Campaign identity",
      deliverables: ["Campaign identity", "Posters", "Social & motion"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/shopping-sundays-city-of-hasselt",
        images: [
          { src: resolveAsset('hasselt-shopping-sundays/project-11-img-11.webp'), enabled: true },
          { src: resolveAsset('hasselt-shopping-sundays/project-11-img-2.webp'), enabled: true },
          { src: resolveAsset('hasselt-shopping-sundays/project-11-img-3.webp'), enabled: true },
          { src: resolveAsset('hasselt-shopping-sundays/project-11-img-4.webp'), enabled: true },
          { src: resolveAsset('hasselt-shopping-sundays/project-11-img-5.webp'), enabled: true },
          { src: resolveAsset('hasselt-shopping-sundays/project-11-img-9.webp'), enabled: true },
          { src: resolveAsset('hasselt-shopping-sundays/project-11-img-10.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/shopping-sundays-city-of-hasselt",
        images: [
          resolveAsset('hasselt-shopping-sundays/project-11-img-5.gif'),
          resolveAsset('hasselt-shopping-sundays/project-11-img-7.gif'),
          resolveAsset('hasselt-shopping-sundays/project-11-img-8.gif'),
          resolveAsset('hasselt-shopping-sundays/project-11-img-9.gif')
        ],
        showLabels: true
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('hasselt-shopping-sundays/project-11-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 14,
    year: "2024",
    date: "2024",
    readTime: "~3 min. read",
    title: "Lil Yachty music video edit",
    shortTitle: "lil-yachty-edit",
    imageAlt: "Lil Yachty music video edit frame",
    description:
      "Fast, punchy Lil Yachty music edit with frame-perfect rhythm, custom transitions and handcrafted overlays tuned to the track.",
    tag: "Motion",
    color: "#fd521a",
    image: resolveAsset('lil-yachty-edit/project-14-img-1.webp'),
    hoverImage: resolveAsset('lil-yachty-edit/project-14-vid-1.webm'),
    sector: "Entertainment",
    services: "Music Video Edit, Motion Design",
    technologies: "After Effects, Premiere Pro, Photoshop",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Deliver a Lil Yachty edit with fast, punchy cuts that amplify the track instead of fighting it.",
      approach:
        "I refined frame-perfect rhythms, handcrafted overlays and custom transitions for a tighter music-edit workflow.",
      result:
        "A sharper music video edit that marks a clear step forward from earlier cuts.",
      role: "Video edit",
      deliverables: ["Music edit", "Custom transitions", "Graphic overlays"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/lil-yachty-video-edit",
        images: [
          { src: resolveAsset('lil-yachty-edit/project-14-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('lil-yachty-edit/project-14-vid-1.webm'),
        videoThumbnail: resolveAsset('lil-yachty-edit/project-14-img-1.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('lil-yachty-edit/project-14-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 15,
    year: "2024",
    date: "2024",
    readTime: "~3 min. read",
    title: "Ice Spice social music video edit",
    shortTitle: "ice-spice-edit",
    imageAlt: "Ice Spice social music video edit frame",
    description:
      "Compact Ice Spice music edit mixing trendy motion presets with custom graphics for social-native pacing and artist energy.",
    tag: "Motion",
    color: "#fd521a",
    image: resolveAsset('ice-spice-edit/project-15-img-1.webp'),
    hoverImage: resolveAsset('ice-spice-edit/project-15-vid-1.webm'),
    sector: "Entertainment",
    services: "Music Video Edit, Motion Templates",
    technologies: "After Effects, Premiere Pro, Photoshop",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Create variation inside a compact Ice Spice format without losing attitude or readability.",
      approach:
        "I mixed trendy motion presets with custom graphics so the edit stays fresh while face and performance stay primary.",
      result:
        "A social-native music edit with high energy and controlled visual variation.",
      role: "Video edit",
      deliverables: ["Music edit", "Motion graphics", "Colour look"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/ice-spice-video-edit",
        images: [
          { src: resolveAsset('ice-spice-edit/project-15-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('ice-spice-edit/project-15-vid-1.webm'),
        videoThumbnail: resolveAsset('ice-spice-edit/project-15-img-1.webp')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/ice-spice-video-edit",
        images: [
          resolveAsset('ice-spice-edit/project-15-vid-1.webm'),
          resolveAsset('ice-spice-edit/project-15-vid-2.webm')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('ice-spice-edit/project-15-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 16,
    year: "2025",
    date: "2025",
    readTime: "~4 min. read",
    title: "Harry Potter inspired 3D bedroom set",
    shortTitle: "harry-potter-chamber-3d",
    imageAlt: "Harry Potter inspired 3D bedroom environment render",
    description:
      "Harry Potter–inspired 3D environment: concept bedroom, full set build and cinematic lighting from idea to final renders.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('harry-potter-chamber-3d/project-16-img-4.webp'),
    hoverImage: resolveAsset('harry-potter-chamber-3d/project-16-img-3.webp'),
    sector: "Entertainment",
    services: "Concept Design, 3D Visualization",
    technologies: "Blender, Photoshop, Illustrator",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Design a Harry Potter–inspired room that shows a full concept-to-space process, not only a pretty still.",
      approach:
        "I designed a playful bedroom concept, built the set in 3D and lit it for cinematic readability.",
      result:
        "An environment piece that demonstrates concept, modelling and presentation as one pipeline.",
      role: "3D environment",
      deliverables: ["Concept", "3D set", "Hero renders"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/harry-potter-secret-chamber",
        images: [
          { src: resolveAsset('harry-potter-chamber-3d/project-16-img-3.webp'), enabled: true },
          { src: resolveAsset('harry-potter-chamber-3d/project-16-img-4.webp'), enabled: true },
          { src: resolveAsset('harry-potter-chamber-3d/project-16-img-3.webp'), enabled: true },
          { src: resolveAsset('harry-potter-chamber-3d/project-16-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/harry-potter-secret-chamber",
        images: [
          resolveAsset('harry-potter-chamber-3d/project-16-img-3.webp'),
          resolveAsset('harry-potter-chamber-3d/project-16-img-4.webp'),
          resolveAsset('harry-potter-chamber-3d/project-16-img-5.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('harry-potter-chamber-3d/project-16-img-4.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 17,
    year: "2025",
    date: "2025",
    readTime: "~4 min. read",
    title: "Rome & Japan architectural 3D study",
    shortTitle: "rome-japan-3d",
    imageAlt: "Rome and Japan architectural 3D atmosphere study",
    description:
      "Architectural atmosphere study merging Rome and Japan — detailed modelling and lighting that keeps both cultures distinct.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('rome-japan-3d/project-17-img-1.webp'),
    hoverImage: resolveAsset('rome-japan-3d/project-17-img-3.webp'),
    sector: "Visualization",
    services: "3D Modeling, Lighting, Rendering",
    technologies: "Blender, Photoshop, Illustrator",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Merge Rome and Japan as contrasting architectural atmospheres in one coherent 3D study.",
      approach:
        "I modelled structures with attention to cultural material language, then sequenced lighting for contrast.",
      result:
        "A dual-world architectural study that keeps two cultures distinct while craft stays consistent.",
      role: "3D environment & art direction",
      deliverables: ["Architectural models", "Atmosphere lighting", "Presentation renders"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/rome-and-japan",
        images: [
          { src: resolveAsset('rome-japan-3d/project-17-img-1.webp'), enabled: true },
          { src: resolveAsset('rome-japan-3d/project-17-img-2.webp'), enabled: true },
          { src: resolveAsset('rome-japan-3d/project-17-img-3.webp'), enabled: true },
          { src: resolveAsset('rome-japan-3d/project-17-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/rome-and-japan",
        images: [
          resolveAsset('rome-japan-3d/project-17-img-1.webp'),
          resolveAsset('rome-japan-3d/project-17-img-2.webp'),
          resolveAsset('rome-japan-3d/project-17-img-3.webp'),
          resolveAsset('rome-japan-3d/project-17-img-4.webp'),
          resolveAsset('rome-japan-3d/project-17-img-5.webp'),
          resolveAsset('rome-japan-3d/project-17-img-6.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('rome-japan-3d/project-17-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 19,
    year: "2024",
    date: "March 2024",
    readTime: "~4 min. read",
    title: "Space Train sci-fi 3D environment",
    shortTitle: "space-train-3d",
    imageAlt: "Space Train sci-fi 3D environment render",
    description:
      "Sci-fi 3D scene translating a Karaska poster into an abandoned space train carriage with materials and cinematic framing.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('space-train-3d/project-19-img-1.webp'),
    hoverImage: resolveAsset('space-train-3d/project-19-img-3.webp'),
    sector: "Entertainment",
    services: "Concept Development, 3D Illustration",
    technologies: "Blender, Photoshop, Illustrator",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Translate a Karaska poster into a believable 3D sci-fi Space Train scene.",
      approach:
        "I built an abandoned carriage with surreal detailing, focusing on silhouette, materials and camera framing.",
      result:
        "A sci-fi environment that respects the poster’s idea while standing as its own 3D world.",
      role: "3D concept & visualisation",
      deliverables: ["Environment model", "Materials", "Hero renders"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/space-train",
        images: [
          { src: resolveAsset('space-train-3d/project-19-img-1.webp'), enabled: true },
          { src: resolveAsset('space-train-3d/project-19-img-2.webp'), enabled: true },
          { src: resolveAsset('space-train-3d/project-19-img-3.webp'), enabled: true },
          { src: resolveAsset('space-train-3d/project-19-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/space-train",
        images: [
          resolveAsset('space-train-3d/project-19-img-1.webp'),
          resolveAsset('space-train-3d/project-19-img-2.webp'),
          resolveAsset('space-train-3d/project-19-img-3.webp'),
          resolveAsset('space-train-3d/project-19-img-4.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('space-train-3d/project-19-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 20,
    year: "2024",
    date: "June 2024",
    readTime: "~6 min. read",
    title: "PXL Esports rebrand & digital platform UI",
    shortTitle: "pxl-esports-rebrand",
    imageAlt: "PXL Esports rebrand and digital platform UI",
    description:
      "PXL Esports rebrand covering visual identity, UI components, app flows and student-facing promotional material through to prototypes.",
    teaser:
      "PXL Esports rebrand — bold identity, UI system and student-facing platform design for a campus esports community.",
    tag: "Branding",
    color: "#13006c",
    image: resolveAsset('pxl-esports-rebrand/project-20-img-1.webp'),
    hoverImage: resolveAsset('pxl-esports-rebrand/project-20-img-3.webp'),
    sector: "Education",
    services: "Brand Identity, Product Design, Campaign Collateral",
    technologies: "Figma, Illustrator, InDesign, Webflow",
    siteUrl: "",
    relatedLinks: {
      insightSlug: 'branding-basics-for-small-businesses',
      servicePath: '/services#branding',
      label: 'Branding',
    },
    caseStudy: {
      challenge:
        "PXL Esports needed a rebrand that resonated with students and a digital platform that felt as energetic as the scene it represented.",
      approach:
        "Starting from analysis and visual direction, I built a flexible identity and designed UI components, app flows and promo material into functional prototypes.",
      result:
        "A coherent, student-facing brand and product system — from identity through to interactive prototypes — delivered across a six-month track.",
      role: "Brand & product designer",
      deliverables: ["Visual identity", "UI component set", "App flows", "Campaign collateral"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/pxl-esports-case",
        images: [
          { src: resolveAsset('pxl-esports-rebrand/project-20-img-1.webp'), enabled: true },
          { src: resolveAsset('pxl-esports-rebrand/project-20-img-1.webp'), enabled: true },
          { src: resolveAsset('pxl-esports-rebrand/project-20-img-3.webp'), enabled: true },
          { src: resolveAsset('pxl-esports-rebrand/project-20-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/pxl-esports-case",
        images: [
          resolveAsset('pxl-esports-rebrand/project-20-img-1.webp'),
          resolveAsset('pxl-esports-rebrand/project-20-img-3.webp'),
          resolveAsset('pxl-esports-rebrand/project-20-img-4.webp'),
          resolveAsset('pxl-esports-rebrand/project-20-img-5.webp'),
          resolveAsset('pxl-esports-rebrand/project-20-img-6.webp'),
          resolveAsset('pxl-esports-rebrand/project-20-img-7.webp'),
          resolveAsset('pxl-esports-rebrand/project-20-img-8.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('pxl-esports-rebrand/project-20-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 21,
    year: "2024",
    date: "March 2024",
    readTime: "~2 min. read",
    title: "Light Beam minimal typography poster",
    shortTitle: "light-beam-poster",
    imageAlt: "Light Beam minimal typography poster",
    description:
      "Minimal poster exploring typographic hierarchy and soft light beams — a calm optical hook with refined print production.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('light-beam-poster/project-21-img-1.webp'),
    hoverImage: resolveAsset('light-beam-poster/project-21-img-2.webp'),
    sector: "Conceptual Design",
    services: "Poster Design, Concept Exploration",
    technologies: "Illustrator, Photoshop",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Explore typographic minimalism where light beams and soft shadows carry the poster’s drama.",
      approach:
        "I tested how beams of light interact with type hierarchy until the composition felt calm but memorable.",
      result:
        "A minimal poster with a clear optical hook and refined production values.",
      role: "Poster design",
      deliverables: ["Key visual", "Poster layout", "Print file"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/light-beam-poster",
        images: [
          { src: resolveAsset('light-beam-poster/project-21-img-1.webp'), enabled: true },
          { src: resolveAsset('light-beam-poster/project-21-img-2.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('light-beam-poster/project-21-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 22,
    year: "2024",
    date: "April 2024",
    readTime: "~3 min. read",
    title: "Personal SK logo design",
    shortTitle: "personal-sk-logo",
    imageAlt: "Personal SK logo design mark",
    description:
      "Personal logo designed from audience research and brand values — a geometric SK mark that works in print and digital at small sizes.",
    tag: "Branding",
    color: "#13006c",
    image: resolveAsset('personal-sk-logo/project-22-img-1.webp'),
    hoverImage: resolveAsset('personal-sk-logo/project-22-img-2.webp'),
    sector: "Personal Brand",
    services: "Logo Design, Visual Identity",
    technologies: "Illustrator, Photoshop, Figma",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Design a personal logo that is memorable, modular and usable in print and digital.",
      approach:
        "After audience and value research I sketched dozens of geometric options, then refined the mark for small sizes.",
      result:
        "A simple modern emblem that prints cleanly and works across web touchpoints.",
      role: "Logo design",
      deliverables: ["Primary mark", "Variations", "Usage basics"],
    },
    config: {
      clientReview: {
        enabled: true,
        title: "WHY I CHOSE THIS LOGO",
        description: "I chose this logo because it is simple and modern. It is easy to remember and it is easy to use. It is also easy to print and it is easy to use on the web."
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/personal-logo",
        images: [
          { src: resolveAsset('personal-sk-logo/project-22-img-1.webp'), enabled: true },
          { src: resolveAsset('personal-sk-logo/project-22-img-2.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/personal-logo",
        images: [
          resolveAsset('personal-sk-logo/project-22-img-1.webp'),
          resolveAsset('personal-sk-logo/project-22-img-2.webp'),
          resolveAsset('personal-sk-logo/project-22-img-3.webp'),
          resolveAsset('personal-sk-logo/project-22-img-4.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('personal-sk-logo/project-22-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 23,
    year: "2021",
    date: "March 2021",
    readTime: "~4 min. read",
    title: "Abandoned Room atmospheric 3D interior",
    shortTitle: "abandoned-room-3d",
    imageAlt: "Abandoned Room atmospheric 3D interior render",
    description:
      "Detailed Blender interior with storytelling focus — weathered materials, props and lighting that make the space feel lived-in.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('abandoned-room-3d/project-23-img-1.webp'),
    hoverImage: resolveAsset('abandoned-room-3d/project-23-img-1.webp'),
    sector: "Visualization",
    services: "3D Modeling, Texturing, Lighting",
    technologies: "Blender, Photoshop, After Effects",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Build an Abandoned Room Blender scene where storytelling leads, not only technical detail.",
      approach:
        "I modelled furniture, crafted weathered materials and lit for narrative falloff so the space feels lived-in.",
      result:
        "An atmospheric interior that reads as a story still as much as a 3D demo.",
      role: "3D environment",
      deliverables: ["Full scene", "Materials", "Hero lighting"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/the-abandoned-room",
        images: [
          { src: resolveAsset('abandoned-room-3d/project-23-img-1.webp'), enabled: true },
          { src: resolveAsset('abandoned-room-3d/project-23-img-2.webp'), enabled: true },
          { src: resolveAsset('abandoned-room-3d/project-23-img-1.webp'), enabled: true },
          { src: resolveAsset('abandoned-room-3d/project-23-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/the-abandoned-room",
        images: [
          resolveAsset('abandoned-room-3d/project-23-img-1.webp'),
          resolveAsset('abandoned-room-3d/project-23-img-2.webp'),
          resolveAsset('abandoned-room-3d/project-23-img-4.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('abandoned-room-3d/project-23-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 24,
    year: "2024",
    date: "March 2024",
    readTime: "~5 min. read",
    title: "Illustrated classic film poster series",
    shortTitle: "film-poster-series",
    imageAlt: "Illustrated classic film poster series design",
    description:
      "Series of film posters reimagining classics as illustrative compositions — hand-drawn lines, digital colour and clear title hierarchy.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('film-poster-series/project-24-img-2.webp'),
    hoverImage: resolveAsset('film-poster-series/project-24-img-3.webp'),
    sector: "Entertainment",
    services: "Illustration, Poster Design, Art Direction",
    technologies: "Illustrator, Photoshop, Procreate",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Reimagine classic films as illustrative poster compositions with a consistent series language.",
      approach:
        "I mixed hand-drawn lines with digital colour and locked hierarchy so title and mood always land first.",
      result:
        "A film poster series with illustrative character and clear campaign DNA.",
      role: "Poster design",
      deliverables: ["Poster series", "Illustration style", "Print exports"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/film-posters",
        images: [
          { src: resolveAsset('film-poster-series/project-24-img-2.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-3.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/film-posters",
        images: [
          resolveAsset('film-poster-series/project-24-img-2.webp'),
          resolveAsset('film-poster-series/project-24-img-3.webp'),
          resolveAsset('film-poster-series/project-24-img-4.webp'),
          resolveAsset('film-poster-series/project-24-img-5.webp'),
          resolveAsset('film-poster-series/project-24-img-6.webp'),
          resolveAsset('film-poster-series/project-24-img-7.webp'),
          resolveAsset('film-poster-series/project-24-img-8.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('film-poster-series/project-24-img-2.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 25,
    year: "2025",
    date: "October 2025",
    readTime: "~5 min. read",
    title: "3D raft model — SyntraPXL class project",
    shortTitle: "raft-3d-model",
    imageAlt: "3D raft model SyntraPXL class project render",
    description:
      "3D raft modelled in 3ds Max and rendered in Blender for SyntraPXL — silhouette, wood materials and water-context presentation.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('raft-3d-model/sander-redndersubstance.webp'),
    hoverImage: resolveAsset('raft-3d-model/sander-3dsmax.webp'),
    sector: "Game Art",
    services: "3D Modeling, Texturing, Lighting",
    technologies: "3DS Max, Blender, Substance Painter, Photoshop",
    siteUrl: "https://www.artstation.com/artwork/x3VPVr",
    caseStudy: {
      challenge:
        "Model and present a raft scene for SyntraPXL 3D class with believable materials and water context.",
      approach:
        "I built the craft in 3ds Max and Blender, focusing on silhouette, wood response and render presentation.",
      result:
        "A class 3D piece that shows modelling and rendering fundamentals in a clear hero still.",
      role: "3D modelling & rendering",
      deliverables: ["Raft model", "Materials", "Hero render"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/film-posters",
        images: [
          { src: resolveAsset('film-poster-series/project-24-img-2.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-2.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-3.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/film-posters",
        images: [
          resolveAsset('raft-3d-model/sander-3dsmax.webp'),
          resolveAsset('raft-3d-model/sander-redndersubstance.webp'),
          resolveAsset('raft-3d-model/sander-rendered.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('raft-3d-model/sander-redndersubstance.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 26,
    year: "2025",
    date: "December 2025",
    readTime: "~5 min. read",
    title: "Breadyz music artist poster designs",
    shortTitle: "breadyz-music-posters",
    imageAlt: "Breadyz music artist poster design",
    description:
      "Music posters for artist Breadyz in Photoshop and Illustrator — expressive type and imagery that stay readable at a distance.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('breadyz-music-posters/pos1.webp'),
    hoverImage: resolveAsset('breadyz-music-posters/pos2.webp'),
    sector: "Music Art",
    services: "Poster Design, Art Direction",
    technologies: "Photoshop, Illustrator",
    siteUrl: "https://soundcloud.com/breadyz",
    caseStudy: {
      challenge:
        "Design music posters for artist Breadyz that feel loud on purpose without becoming illegible.",
      approach:
        "In Photoshop and Illustrator I balanced expressive type and imagery so artist info still reads at distance.",
      result:
        "Poster designs with strong shelf presence and clear visual attitude for the artist.",
      role: "Poster design",
      deliverables: ["Music posters", "Type lockups", "Print files"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/film-posters",
        images: [
          { src: resolveAsset('film-poster-series/project-24-img-2.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-2.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-3.webp'), enabled: true },
          { src: resolveAsset('film-poster-series/project-24-img-4.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/music-posters",
        images: [
          resolveAsset('breadyz-music-posters/pos1.webp'),
          resolveAsset('breadyz-music-posters/pos2.webp'),
          resolveAsset('breadyz-music-posters/pos3.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('breadyz-music-posters/pos3.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 27,
    year: "2024",
    date: "December 2024",
    readTime: "~5 min. read",
    title: "School data visualisation design project",
    shortTitle: "school-dataviz",
    imageAlt: "School data visualisation design charts",
    description:
      "School dataviz project using Blender and Photoshop — chart hierarchy and dimensional treatments that make dense data approachable.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('school-dataviz/peviz.webp'),
    hoverImage: resolveAsset('school-dataviz/dataviz2.webp'),
    sector: "Data Visualization",
    services: "Data Visualization Design, Art Direction",
    technologies: "Photoshop, Illustrator",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Turn a school dataviz brief into visuals that explain information without drowning in charts.",
      approach:
        "I used Blender and Photoshop to build hierarchy, colour coding and dimensional chart treatments.",
      result:
        "A dataviz project that makes dense information feel approachable and designed.",
      role: "Data visualisation",
      deliverables: ["Chart visuals", "3D data treatments", "Presentation boards"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/dataviz-pe",
        images: [
          { src: resolveAsset('school-dataviz/peviz.webp'), enabled: true },
          { src: resolveAsset('school-dataviz/dataviz2.webp'), enabled: true },
          { src: resolveAsset('school-dataviz/dataviz3.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/dataviz-pe",
        images: [
          resolveAsset('school-dataviz/peviz.webp'),
          resolveAsset('school-dataviz/dataviz2.webp'),
          resolveAsset('school-dataviz/dataviz3.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('school-dataviz/peviz.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 28,
    year: "2025",
    date: "April 2025",
    readTime: "~5 min. read",
    title: "Friends of Cartel data visualisation",
    shortTitle: "cartel-dataviz",
    imageAlt: "Friends of Cartel data visualisation design",
    description:
      "Agency dataviz for Friends of Cartel in Illustrator and Photoshop — clear information hierarchy with polished presentation craft.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('cartel-dataviz/1.webp'),
    hoverImage: resolveAsset('cartel-dataviz/2.webp'),
    sector: "Branding",
    services: "Data Visualization Design, Art Direction",
    technologies: "Photoshop, Illustrator",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Create a Friends of Cartel dataviz piece that feels on-brand and readable for agency use.",
      approach:
        "In Illustrator and Photoshop I designed clear information hierarchy with Cartel-appropriate craft.",
      result:
        "A polished dataviz deliverable suited to agency presentation and storytelling.",
      role: "Data visualisation",
      deliverables: ["Dataviz layouts", "Infographic system", "Export set"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/dataviz-pe",
        images: [
          { src: resolveAsset('school-dataviz/peviz.webp'), enabled: true },
          { src: resolveAsset('school-dataviz/dataviz2.webp'), enabled: true },
          { src: resolveAsset('school-dataviz/dataviz3.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/dataviz-cartel",
        images: [
          resolveAsset('cartel-dataviz/1.webp'),
          resolveAsset('cartel-dataviz/2.webp'),
          resolveAsset('cartel-dataviz/3.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('cartel-dataviz/1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 29,
    year: "2026",
    date: "April 2025",
    readTime: "~5 min. read",
    title: "Dragon creature sculpt in ZBrush",
    shortTitle: "dragon-zbrush-sculpt",
    imageAlt: "Dragon creature ZBrush 3D sculpt",
    description:
      "Dragon creature sculpt in ZBrush for school — anatomy landmarks, surface detail and readable turnaround presentation.",
    tag: "3D",
    color: "#8ea78f",
    image: resolveAsset('dragon-zbrush-sculpt/draak-front.webp'),
    hoverImage: resolveAsset('dragon-zbrush-sculpt/low-draak-front.webp'),
    sector: "3D Modeling",
    services: "3D Modeling, Texturing, Lighting",
    technologies: "Zbrush",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Sculpt a dragon that shows form, surface and silhouette clearly for a school 3D brief.",
      approach:
        "In ZBrush I built anatomy landmarks and presented the creature for readable turnarounds.",
      result:
        "A creature sculpt that demonstrates form language and presentation discipline.",
      role: "3D sculpting",
      deliverables: ["ZBrush sculpt", "Turnaround renders", "Detail views"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/draak-zbrush",
        images: [
          { src: resolveAsset('dragon-zbrush-sculpt/low-draak-front.webp'), enabled: true },
          { src: resolveAsset('dragon-zbrush-sculpt/low-draak-3.webp'), enabled: true },
          { src: resolveAsset('dragon-zbrush-sculpt/low-draak-top.webp'), enabled: true },
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/draak-zbrush",
        images: [
          resolveAsset('dragon-zbrush-sculpt/draak-front.webp'),
          resolveAsset('dragon-zbrush-sculpt/draak-3.webp'),
          resolveAsset('dragon-zbrush-sculpt/draak-detail.webp'),
          resolveAsset('dragon-zbrush-sculpt/draak-top.webp'),
          resolveAsset('dragon-zbrush-sculpt/draak-side.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('dragon-zbrush-sculpt/draak-front.webp')
      },
      modelViewer: {
        enabled: true,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 30,
    year: "2025",
    date: "2025",
    readTime: "~3 min. read",
    title: "HDRI lighting — photorealistic 3D room",
    shortTitle: "hdri-realistic-room",
    imageAlt: "HDRI photorealistic 3D room lighting study",
    description:
      "Photoreal interior study from a single HDRI — exposure matching, reflections and materials that share one light reality.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('hdri-realistic-room/project-12-vid-1.webm'),
    hoverImage: resolveAsset('hdri-realistic-room/project-12-vid-1.webm'),
    sector: "Visualization",
    services: "3D Modeling, Lighting, Look Development",
    technologies: "Blender, Photoshop, After Effects",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Turn a single HDRI into a fully realized photorealistic interior with consistent light reality.",
      approach:
        "I matched exposure, reflections and prop scale so materials and the dome share one lighting world.",
      result:
        "A photoreal room study that demonstrates HDRI lighting and lookdev accuracy.",
      role: "3D lighting & lookdev",
      deliverables: ["Lit interior", "HDRI setup", "Still renders"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/hdri-to-realistic-room",
        images: [
          { src: resolveAsset('hdri-realistic-room/project-12-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('hdri-realistic-room/project-12-vid-1.webm'),
        videoThumbnail: resolveAsset('hdri-realistic-room/project-12-img-1.webp')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/hdri-to-realistic-room",
        images: [
          resolveAsset('hdri-realistic-room/project-12-img-1.webp'),
          resolveAsset('hdri-realistic-room/project-12-vid-1.webm')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('hdri-realistic-room/project-12-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 31,
    year: "2025",
    date: "2025",
    readTime: "~4 min. read",
    title: "Beauty Studio Olga web & UI/UX design",
    shortTitle: "beauty-studio-olga-web",
    imageAlt: "Beauty Studio Olga web and UI UX design",
    description:
      "Calm, premium web and UI/UX for Beauty Studio Olga — visual identity and interface focused on effortless booking on every device.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('beauty-studio-olga-web/project-13-img-1-png.webp'),
    hoverImage: resolveAsset('beauty-studio-olga-web/project-13-img-2.webp'),
    sector: "Beauty & Wellness",
    services: "Web Design, UI/UX Design, Visual Identity",
    technologies: "Figma, Photoshop, Illustrator",
    siteUrl: "",
    caseStudy: {
      challenge:
        "A beauty salon needed an online presence that felt calm and premium while making booking and browsing effortless on any device.",
      approach:
        "I designed the visual identity and interface around a soft aesthetic, with a clear, conversion-focused structure that keeps booking front and centre.",
      result:
        "A premium-feeling site and UI that balances a gentle look with an easy, effortless path to booking — credible and on-brand on every screen.",
      role: "Web & UI/UX designer",
      deliverables: ["Visual identity", "Responsive UI", "Booking flow", "Design system"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/beauty-studio-olga",
        images: [
          { src: resolveAsset('beauty-studio-olga-web/project-13-img-1-png.webp'), enabled: true },
          { src: resolveAsset('beauty-studio-olga-web/project-13-img-1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/beauty-studio-olga",
        images: [
          resolveAsset('beauty-studio-olga-web/project-13-img-1-png.webp'),
          resolveAsset('beauty-studio-olga-web/project-13-img-1.webp'),
          resolveAsset('beauty-studio-olga-web/project-13-img-2.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('beauty-studio-olga-web/project-13-img-1-png.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 32,
    year: "2023",
    date: "2023",
    readTime: "~4 min. read",
    title: "Loneliness editorial booklet design",
    shortTitle: "loneliness-editorial-booklet",
    imageAlt: "Loneliness editorial booklet typography spread",
    description:
      "Editorial booklet exploring isolation through typography, imagery and paced spreads — quiet whitespace with moments of visual tension.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('loneliness-editorial-booklet/project-18-img-1.webp'),
    hoverImage: resolveAsset('loneliness-editorial-booklet/project-18-img-2.webp'),
    sector: "Editorial & Print",
    services: "Editorial Design, Print, Art Direction",
    technologies: "InDesign, Photoshop, Illustrator",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Explore isolation in an editorial booklet without cliché imagery or unreadable type.",
      approach:
        "I designed layout, grid and image treatment so each spread carries its own emotional rhythm with quiet whitespace and tension.",
      result:
        "A print booklet where mood and readability work together across the full page sequence.",
      role: "Editorial design",
      deliverables: ["Booklet layout", "Typography system", "Print spreads"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/loneliness-booklet",
        images: [
          { src: resolveAsset('loneliness-editorial-booklet/project-18-img-3.webp'), enabled: true },
          { src: resolveAsset('loneliness-editorial-booklet/project-18-img-4.webp'), enabled: true },
          { src: resolveAsset('loneliness-editorial-booklet/project-18-img-5.webp'), enabled: true },
          { src: resolveAsset('loneliness-editorial-booklet/project-18-img-6.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/loneliness-booklet",
        images: [
          resolveAsset('loneliness-editorial-booklet/project-18-img-3.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-4.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-5.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-6.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-7.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-8.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-9.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('loneliness-editorial-booklet/project-18-img-1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      },
      brandBook: {
        enabled: true,
        title: "",
        pages: [
          resolveAsset('loneliness-editorial-booklet/project-18-img-1.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-2.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-3.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-4.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-5.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-6.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-7.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-8.webp'),
          resolveAsset('loneliness-editorial-booklet/project-18-img-9.webp')
        ]
      }
    }
  },
  {
    id: 33,
    year: "2026",
    date: "2026",
    readTime: "~4 min. read",
    title: "3D character sculpt — Crown Woman",
    shortTitle: "crown-woman-3d-character",
    imageAlt: "Crown Woman 3D character sculpt turnaround",
    description:
      "3D character study from high-poly sculpt to game-ready low-poly — silhouette, topology and turnarounds for Crown Woman.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('crown-woman-3d-character/roze-hp-front.webp'),
    hoverImage: resolveAsset('crown-woman-3d-character/roze-lp-front.webp'),
    sector: "Game Art",
    services: "3D Modeling, Character Art, Hi-poly to Low-poly",
    technologies: "ZBrush, Blender, Substance Painter",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Take Crown Woman from a high-poly sculpt to a clean, game-ready low-poly model without losing silhouette.",
      approach:
        "I worked through topology and form across multiple views so the design stays readable from every angle.",
      result:
        "A character study that documents a full hi-poly to low-poly pipeline.",
      role: "3D character / game art",
      deliverables: ["Hi-poly sculpt", "Low-poly model", "Turnaround views"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/kroon-vrouw",
        images: [
          { src: resolveAsset('crown-woman-3d-character/roze-lp-front.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-side.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-back.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-3.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/kroon-vrouw",
        images: [
          resolveAsset('crown-woman-3d-character/roze-hp-front.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-side.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-back.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-3.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('crown-woman-3d-character/roze-hp-front.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 34,
    year: "2026",
    date: "2026",
    readTime: "~5 min. read",
    title: "Factory-to-home architectural visualization",
    shortTitle: "factory-residential-archviz",
    imageAlt: "Factory to residential architectural visualization render",
    description:
      "Architectural visualization of a modern factory reimagined as residential space — modelling, V-Ray/Vantage renders and a collaborative walkthrough film.",
    tag: "3D",
    color: "#301934",
    image: resolveAsset('factory-residential-archviz/arch1.webp'),
    hoverImage: resolveAsset('factory-residential-archviz/archviz-sander-armin-stephe.webm'),
    sector: "Architecture / Game Art",
    services: "3D Modeling, Architectural Visualization",
    technologies: "3ds Max, V-Ray, Vantage, After Effects",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Show a modern factory-to-residential transformation as archviz that feels believable for living, not only technical.",
      approach:
        "I modelled the architecture, set human-scale cameras, rendered with V-Ray / Vantage, and cut a short film with collaborators to sell atmosphere and reuse of space.",
      result:
        "An archviz case with hero stills and a walkthrough video that explains the residential conversion.",
      role: "3D modelling, archviz & edit",
      deliverables: ["Architectural model", "Hero stills", "Walkthrough video"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/archviz",
        images: [
          { src: resolveAsset('factory-residential-archviz/arch1.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('factory-residential-archviz/archviz-sander-armin-stephe.webm'),
        videoThumbnail: resolveAsset('factory-residential-archviz/arch1.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/archviz",
        images: [
          resolveAsset('factory-residential-archviz/arch1.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('factory-residential-archviz/arch1.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 35,
    year: "2026",
    date: "2026",
    readTime: "~4 min. read",
    title: "3D & VFX demoreel 2026",
    shortTitle: "demoreel-2026-3d-vfx",
    imageAlt: "3D and VFX demoreel 2026 title card",
    description:
      "Demoreel 2026 packaging a year of 3D modelling, lookdev, archviz and VFX into one paced reel for applications and portfolio reviews.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('demoreel-2026-3d-vfx/demoreel.webp'),
    hoverImage: resolveAsset('demoreel-2026-3d-vfx/demoreel-sander-kuyken.webm'),
    sector: "Game Art",
    services: "3D Modeling, Architectural Visualization, Editing",
    technologies: "ZBrush, 3ds Max, V-Ray, Vantage, After Effects, Blender",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Package a year of class and personal 3D/VFX learning into a demoreel hiring eyes can scan quickly.",
      approach:
        "I selected the strongest shots, graded for consistency, and sequenced for pacing — impact first, then craft variety.",
      result:
        "Demoreel 2026: a clear skill overview across modelling, lookdev and motion for applications and portfolio use.",
      role: "Edit, grade & shot selection",
      deliverables: ["Demoreel film", "Title card", "Shot selection"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/demoreel-2026",
        images: [
          { src: resolveAsset('demoreel-2026-3d-vfx/demoreel.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('demoreel-2026-3d-vfx/demoreel-sander-kuyken.webm'),
        videoThumbnail: resolveAsset('demoreel-2026-3d-vfx/demoreel.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/demoreel-2026",
        images: [
          resolveAsset('demoreel-2026-3d-vfx/demoreel.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('demoreel-2026-3d-vfx/demoreel.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 36,
    year: "2026",
    date: "2026",
    readTime: "~4 min. read",
    title: "CPROEF 2026 — 3D environment showcase",
    shortTitle: "cproef-2026-3d-environment",
    imageAlt: "CPROEF 2026 3D environment showcase render",
    description:
      "CPROEF 2026 free-choice 3D environment: end-to-end modelling and cinematic presentation for class delivery and portfolio.",
    teaser:
      "Full 3D environment for CPROEF 2026 — modelling, lighting and cinematic presentation from free brief to final film.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('cproef-2026-3d-environment/eindwerk.webp'),
    hoverImage: resolveAsset('cproef-2026-3d-environment/eindwerk-sander-kuyken.webm'),
    sector: "Game Art",
    services: "3D Modeling, Architectural Visualization",
    technologies: "ZBrush, 3DS max, Vray, Vantage, After Effects, Blender",
    siteUrl: "",
    caseStudy: {
      challenge:
        "For CPROEF 2026, freely choose and build a 3D environment that proves modelling and presentation craft.",
      approach:
        "I defined a strong environment concept, built the space end-to-end, and presented it with a cinematic pass for class delivery.",
      result:
        "A finished environment case showing ownership from brief choice through to final render and video.",
      role: "3D environment",
      deliverables: ["Environment model", "Hero render", "Presentation video"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/kroon-vrouw",
        images: [
          { src: resolveAsset('crown-woman-3d-character/roze-lp-front.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-side.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-back.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-3.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('cproef-2026-3d-environment/eindwerk-sander-kuyken.webm'),
        videoThumbnail: resolveAsset('cproef-2026-3d-environment/eindwerk.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/kroon-vrouw",
        images: [
          resolveAsset('crown-woman-3d-character/roze-hp-front.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-side.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-back.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-3.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('cproef-2026-3d-environment/eindwerk.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 37,
    year: "2026",
    date: "2026",
    readTime: "~4 min. read",
    title: "Personal logo rework & brandbook",
    shortTitle: "sk-logo-brandbook",
    imageAlt: "Personal SK logo rework and brandbook page",
    description:
      "Rework of the personal SK logo plus an archviz project mark, documented in brandbook pages for clear space, colour and misuse rules.",
    tag: "Branding",
    color: "#301934",
    image: resolveAsset('sk-logo-brandbook/artboard-1.webp'),
    hoverImage: resolveAsset('sk-logo-brandbook/artboard-11.webp'),
    sector: "Personal Brand",
    services: "Logo Design, Visual Identity",
    technologies: "Illustrator, Photoshop",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Rework the personal logo and create an archviz mark, then document both so usage stays consistent.",
      approach:
        "I rebuilt the marks, explored applications across artboards, and assembled brandbook pages for clear space and misuse rules.",
      result:
        "A brandbook foundation that keeps personal and project identity consistent across touchpoints.",
      role: "Identity & brand guidelines",
      deliverables: ["Logo rework", "Archviz logo", "Brandbook pages"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/kroon-vrouw",
        images: [
          { src: resolveAsset('crown-woman-3d-character/roze-lp-front.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-side.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-back.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-3.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/kroon-vrouw",
        images: [
          resolveAsset('crown-woman-3d-character/roze-hp-front.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-side.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-back.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-3.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('sk-logo-brandbook/artboard-1.webp')
      },
      brandBook: {
        enabled: true,
        title: "Brandbook",
        pages: [
          resolveAsset('sk-logo-brandbook/artboard-1.webp'),
          resolveAsset('sk-logo-brandbook/artboard-2.webp'),
          resolveAsset('sk-logo-brandbook/artboard-3.webp'),
          resolveAsset('sk-logo-brandbook/artboard-4.webp'),
          resolveAsset('sk-logo-brandbook/artboard-5.webp'),
          resolveAsset('sk-logo-brandbook/artboard-9.webp'),
          resolveAsset('sk-logo-brandbook/artboard-11.webp'),
          resolveAsset('sk-logo-brandbook/artboard-12.webp'),
          resolveAsset('sk-logo-brandbook/artboard-13.webp'),
          resolveAsset('sk-logo-brandbook/artboard-14.webp'),
          resolveAsset('sk-logo-brandbook/artboard-15.webp'),
          resolveAsset('sk-logo-brandbook/artboard-16.webp'),
          resolveAsset('sk-logo-brandbook/artboard-17.webp'),
          resolveAsset('sk-logo-brandbook/artboard-18.webp'),
          resolveAsset('sk-logo-brandbook/artboard-19.webp'),
          resolveAsset('sk-logo-brandbook/artboard-37.webp'),
          resolveAsset('sk-logo-brandbook/artboard-19-copy.webp'),
          resolveAsset('sk-logo-brandbook/artboard-41.webp'),
        ]
      }
    }
  },
  {
    id: 38,
    year: "2022",
    date: "2022",
    readTime: "~4 min. read",
    title: "Charlie Chaplin film voice-over edit",
    shortTitle: "chaplin-voiceover-edit",
    imageAlt: "Charlie Chaplin film voice-over edit still",
    description:
      "High-school film project: Charlie Chaplin clip with an original voice-over performance, finished in Premiere and After Effects.",
    tag: "Motion",
    color: "#301934",
    image: resolveAsset('chaplin-voiceover-edit/charli.webp'),
    hoverImage: resolveAsset('chaplin-voiceover-edit/lion-cage-sander-kuyken-6tmm.webm'),
    sector: "Film",
    services: "Voice Over",
    technologies: "After Effects, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "For a high-school film project, choose a Charlie Chaplin piece and deliver an original voice-over performance.",
      approach:
        "I selected the clip, wrote and recorded my own voice-over, and finished the edit in Premiere / After Effects.",
      result:
        "A finished homage edit that combines classic cinema source with a personal spoken layer.",
      role: "Voice-over & edit",
      deliverables: ["Voice-over", "Edited film", "Sound mix"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/kroon-vrouw",
        images: [
          { src: resolveAsset('crown-woman-3d-character/roze-lp-front.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-side.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-back.webp'), enabled: true },
          { src: resolveAsset('crown-woman-3d-character/roze-lp-3.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('chaplin-voiceover-edit/lion-cage-sander-kuyken-6tmm.webm'),
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/kroon-vrouw",
        images: [
          resolveAsset('crown-woman-3d-character/roze-hp-front.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-side.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-back.webp'),
          resolveAsset('crown-woman-3d-character/roze-hp-3.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('chaplin-voiceover-edit/charli.webp')
      },
      brandBook: {
        enabled: false,
        title: "Brandbook personal logo",
        pages: [
          resolveAsset('sk-logo-brandbook/artboard-1.webp'),
          resolveAsset('sk-logo-brandbook/artboard-2.webp'),
          resolveAsset('sk-logo-brandbook/artboard-3.webp'),
          resolveAsset('sk-logo-brandbook/artboard-4.webp'),
          resolveAsset('sk-logo-brandbook/artboard-5.webp'),
          resolveAsset('sk-logo-brandbook/artboard-9.webp'),
          resolveAsset('sk-logo-brandbook/artboard-11.webp'),
          resolveAsset('sk-logo-brandbook/artboard-12.webp'),
          resolveAsset('sk-logo-brandbook/artboard-13.webp'),
          resolveAsset('sk-logo-brandbook/artboard-14.webp'),
          resolveAsset('sk-logo-brandbook/artboard-15.webp'),
          resolveAsset('sk-logo-brandbook/artboard-16.webp'),
          resolveAsset('sk-logo-brandbook/artboard-17.webp'),
          resolveAsset('sk-logo-brandbook/artboard-18.webp'),
          resolveAsset('sk-logo-brandbook/artboard-19.webp')
        ]
      }
    }
  },
  {
    id: 39,
    year: "2026",
    date: "August 2026",
    readTime: "~7 min. read",
    title: "SK Design portfolio website & brand system",
    shortTitle: "skdesign-portfolio-web",
    imageAlt: "SK Design portfolio website homepage screenshot",
    description:
      "Self-initiated skdesign.be build: identity system, conversion-minded UX, motion, works archive and insights — live proof of brand, web and craft together.",
    tag: "Branding",
    color: "#f97b22",
    image: resolveAsset('skdesign-portfolio-web/home.webp'),
    hoverImage: resolveAsset('skdesign-portfolio-web/works.webp'),
    relatedLinks: {
      insightSlug: 'website-that-actually-converts',
      servicePath: '/brand-guidelines',
      label: 'Brand guidelines',
    },
    sector: "Personal brand / Studio",
    services: "Web Design, Brand Identity, Motion, Front-end",
    technologies: "React, Tailwind, Framer Motion, GSAP, Figma",
    siteUrl: "https://skdesign.be/",
    caseStudy: {
      challenge:
        "As a designer-developer I needed a portfolio that sells the work and the process — not a template grid with a logo stuck on top. It also had to carry branding, motion, 3D and web cases under one clear identity.",
      approach:
        "I started from the SK mark and cream/ink/orange system, then designed a conversion-first homepage, structured works pages with case narrative, and shipped the front-end myself in React. Insights and brand guidelines extend the same voice beyond project stills.",
      result:
        "A self-initiated studio site that is both case study and product: live at skdesign.be, with documented brand rules and room to grow as new work and writing land.",
      role: "Brand, UX, motion & front-end build",
      deliverables: [
        "Visual identity",
        "Website design & build",
        "Works case system",
        "Brand guidelines",
        "Insights content",
      ],
    },
    config: {
      clientReview: {
        enabled: true,
        title: "Visit the live site",
        description: "https://skdesign.be/"
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/skdesign-portfolio",
        images: [
          { src: resolveAsset('skdesign-portfolio-web/works.webp'), enabled: true },
          { src: resolveAsset('skdesign-portfolio-web/brand-guidelines.webp'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/skdesign-portfolio",
        images: [
          resolveAsset('skdesign-portfolio-web/home.webp'),
          resolveAsset('skdesign-portfolio-web/works.webp'),
          resolveAsset('skdesign-portfolio-web/brand-guidelines.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('skdesign-portfolio-web/home.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 40,
    year: "2026",
    date: "August 2026",
    readTime: "~4 min. read",
    title: "Animated poster series — skate, monk and climb",
    shortTitle: "poster-animations",
    imageAlt: "Animated skate poster still from a three-poster motion series",
    description:
      "Three print-style posters brought to life as short loops — skate, monk and climb — each with its own rhythm, type and colour, made to hold as a still and move as a clip.",
    teaser:
      "Poster motion series: skate, monk and climb loops that keep print composition while adding timed type and colour.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('poster-animations/skate.webp'),
    relatedLinks: {
      insightSlug: 'what-motion-design-adds-to-a-brand',
      servicePath: '/services#motion-design',
      label: 'Motion design',
    },
    hoverImage: resolveAsset('poster-animations/skate.webm'),
    sector: "Culture and sport",
    services: "Motion Design, Poster Animation, Art Direction",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Turn three poster concepts — skate culture, a monk piece, and climbing — into motion without losing the print read of type, crop and colour.",
      approach:
        "I treated each poster as a loop: hold the composition, then time type, texture and colour so skate feels fast, the monk piece stays still and climb keeps tension.",
      result:
        "A three-clip poster series that works as wall graphics and as social / showreel motion from the same art direction.",
      role: "Motion design & art direction",
      deliverables: ["Skate poster loop", "Monk poster loop", "Climb poster loop"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/poster-animations",
        images: [],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/poster-animations",
        images: [
          resolveAsset('poster-animations/skate.webm'),
          resolveAsset('poster-animations/monk.webm'),
          resolveAsset('poster-animations/klimmen.webm')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('poster-animations/skate.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 41,
    year: "2026",
    date: "July 2026",
    readTime: "~4 min. read",
    title: "SaaS product motion explainer",
    shortTitle: "saas-animation",
    imageAlt: "SaaS product motion explainer UI animation still",
    description:
      "Short product loop for a SaaS interface — UI motion that makes value readable in a few seconds, built for landing pages, ads and onboarding.",
    teaser:
      "Product explainer motion: a SaaS UI loop that sells the flow instead of a static screenshot.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('saas-animation/saas.webp'),
    relatedLinks: {
      insightSlug: 'what-motion-design-adds-to-a-brand',
      servicePath: '/services#motion-design',
      label: 'Motion design',
    },
    hoverImage: resolveAsset('saas-animation/saas.webm'),
    sector: "Software / Product",
    services: "Product Motion, UI Animation, Explainer",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "A SaaS product needed motion that shows what the product does — not a decorative logo sting or a mute screen recording.",
      approach:
        "I staged the interface as a timed explainer: hierarchy, cursor/UI beats and copy so the loop reads as a product story in under twenty seconds.",
      result:
        "A reusable product clip for web, ads and onboarding that makes the SaaS flow obvious without a voice-over.",
      role: "Product motion design",
      deliverables: ["Explainer loop", "UI animation", "Web-ready export"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/saas-animation",
        images: [],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('saas-animation/saas.webm'),
        videoThumbnail: resolveAsset('saas-animation/saas.webp')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/saas-animation",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('saas-animation/saas.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  },
  {
    id: 42,
    year: "2026",
    date: "June 2026",
    readTime: "~4 min. read",
    title: "World Cup motion opener and goal sequence",
    shortTitle: "worldcup-animation",
    imageAlt: "World Cup broadcast-style motion opener still",
    description:
      "Broadcast-style sport motion for World Cup 2026: a title opener and a goal beat — type, pace and impact built for intro packages and highlight cuts.",
    teaser:
      "World Cup 2026 motion: opener plus goal sequence in broadcast sport language.",
    tag: "Motion",
    color: "#13006c",
    image: resolveAsset('worldcup-animation/worldcupintro.webp'),
    relatedLinks: {
      insightSlug: 'what-motion-design-adds-to-a-brand',
      servicePath: '/services#motion-design',
      label: 'Motion design',
    },
    hoverImage: resolveAsset('worldcup-animation/worldcupintro.webm'),
    sector: "Sport / Broadcast",
    services: "Motion Design, Broadcast Opener, Sequence Design",
    technologies: "After Effects, Cinema 4D / Blender, Premiere Pro",
    siteUrl: "",
    caseStudy: {
      challenge:
        "Sport motion has to hit instantly — an opener that feels like a broadcast ident, then a goal beat with enough impact to cut into highlights.",
      approach:
        "I split the piece into two sequences: a World Cup intro for title energy, then a goal sting with tighter timing, type and hit-frames for the score moment.",
      result:
        "A two-clip package that can lead a reel or sit as opener and goal punctuation in a longer sport edit.",
      role: "Motion design",
      deliverables: ["Broadcast opener", "Goal sequence", "Showreel cuts"],
    },
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/worldcup-animation",
        images: [],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('worldcup-animation/worldcupintro.webm'),
        videoThumbnail: resolveAsset('worldcup-animation/worldcupintro.webp')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/worldcup-animation",
        images: [
          resolveAsset('worldcup-animation/worldcupintro.webm'),
          resolveAsset('worldcup-animation/goal.webm')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('worldcup-animation/worldcupintro.webp')
      },
      modelViewer: {
        enabled: false,
        modelSrc: "",
        title: "3D MODEL"
      }
    }
  }

];

const splitTagValue = (rawValue) => {
  if (!rawValue) return [];

  const values = Array.isArray(rawValue) ? rawValue : [rawValue];

  return values
    .flatMap((value) =>
      typeof value === 'string'
        ? value
            .split(',')
            .map((tag) => tag.trim())
        : []
    )
    .filter(Boolean);
};

export const getProjectTags = (project) => {
  if (!project) return [];
  return splitTagValue(project.tag);
};

// Helper om tags te extraheren
// Homepage Selected Works — one strong case per discipline tag
export const FEATURED_WORK_IDS = [20, 1, 3, 36]; // Branding, Design, Motion, 3D

export const getFeaturedProjects = () =>
  FEATURED_WORK_IDS.map((id) => projects.find((p) => p.id === id)).filter(Boolean);

export const getAllTags = () => {
  const tagSet = new Set();
  projects.forEach((project) => {
    getProjectTags(project).forEach((tag) => tagSet.add(tag));
  });
  return Array.from(tagSet);
};

// Helper om alle unieke jaren te extraheren
export const getAllYears = () => {
  const years = [...new Set(projects.map(p => p.year))];
  return years.sort((a, b) => b - a); // Sorteer van nieuw naar oud
};

// Helper om een specifiek project op te halen op basis van ID.
// Geeft null terug bij een onbekend ID, zodat /project/9999 een echte
// niet-gevonden-pagina toont in plaats van stil het eerste project.
export const getProjectById = (projectId) => {
  return projects.find(p => p.id === projectId) || null;
};

// Helper om het volgende project te vinden op basis van datum
export const getNextProject = (currentProjectId) => {
  // Sorteer projecten op datum (nieuwste eerst)
  const sortedProjects = [...projects].sort((a, b) => 
    new Date(b.date) - new Date(a.date)
  );
  
  // Vind het huidige project
  const currentIndex = sortedProjects.findIndex(p => p.id === currentProjectId);
  
  // Als het het laatste project is, ga terug naar het eerste
  // Anders, neem het volgende project
  const nextIndex = currentIndex === sortedProjects.length - 1 ? 0 : currentIndex + 1;
  
  return sortedProjects[nextIndex];
};

